<template>
  <div class="container card card-body my-3 p-3">
    <div class="row mb-3">
      <div class="col">
        <h5>Personal</h5>
        <p>
          <strong>Address 1:</strong>
          {{ plot.build.user.address_1 ?? "N/A" }}
        </p>

        <p>
          <strong>Address 2:</strong>
          {{ plot.build.user.address_2 ?? "N/A" }}
        </p>

        <p>
          <strong>Postcode:</strong>
          {{ plot.build.user.postcode ?? "N/A" }}
        </p>

        <p>
          <strong>Town:</strong>
          {{ plot.build.user.town ?? "N/A" }}
        </p>

        <p>
          <strong>County:</strong>
          {{ plot.build.user.county ?? "N/A" }}
        </p>

        <p>
          <strong>Country:</strong>
          {{ plot.build.user.country ?? "N/A" }}
        </p>

        <p>
          <strong>Phone number:</strong>
          {{ plot.build.user.phone ?? "N/A" }}
        </p>
      </div>

      <div class="col">
        <h5>Solicitor</h5>
        <p>
          <strong>Solicitor:</strong>
          {{ plot.build.user.solicitor ?? "N/A" }}
        </p>

        <p>
          <strong>Solicitor Phone No.</strong>
          {{ plot.build.user.solicitor_phone ?? "N/A" }}
        </p>

        <p>
          <strong>Solicitor Email:</strong>
          {{ plot.build.user.solicitor_email ?? "N/A" }}
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <h5>Customer Care</h5>
        <p>
          <strong>Customer Care Phone No.</strong>
          {{ plot.build.user.customer_care_phone ?? "N/A" }}
        </p>

        <p>
          <strong>Customer Care Email:</strong>
          {{ plot.build.user.customer_care_email ?? "N/A" }}
        </p>
      </div>

      <div class="col">
        <h5>New Homes Team</h5>
        <p>
          <strong>New Homes Team:</strong>
          {{ plot.build.user.new_homes_team ?? "N/A" }}
        </p>

        <p>
          <strong>New Homes Team Phone No.</strong>
          {{ plot.build.user.new_homes_team_phone ?? "N/A" }}
        </p>

        <p>
          <strong>New Homes Team Email:</strong>
          {{ plot.build.user.new_homes_team_email ?? "N/A" }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserContactComponent",

  props: {
    plot: {
      type: Object,
      required: true,
    },
  },
};
</script>
